import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../../common/Footer";
import Header from "../../common/Header";
import Tutorial from "./sub/Tutorial";
import Section from "../../common/Section";
import LandingSlogan from "./sub/LandingSlogan";
import Benefits from "./sub/Benefits";
import Counters from "./sub/Counters";
import { getStatistics } from "../../state/landing-page";
import { getNumberDisplayValue } from "../../utils/format";
import News from "./sub/News";
import Clients from "./sub/Clients";

type State = {
  title: string;
  content: string;
  oil_request_count: string;
  liters: string;
  total_sum: string;
};

class LandingPage extends React.PureComponent<any, State> {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      content: "",
      oil_request_count: "x",
      liters: "x",
      total_sum: "x",
    };
  }

  componentDidMount(): void {
    getStatistics()
      .then((data) => {
        this.setState({
          oil_request_count: data[0].total,
          liters: getNumberDisplayValue(data[1].liters),
          total_sum: getNumberDisplayValue(data[2].totalSum),
        });
      })
      .catch((err) => {
        console.error("Could not fetch counts:");
        console.error(err);
      });
  }

  render() {
    const { title, content, oil_request_count, liters, total_sum } = this.state;

    return (
      <div className="landing-page">
        <Helmet>
          <title>
            Turgoil - vedelkütuse hanked: bensiin 95, bensiin 98, diislikütus,
            erimärgistusega diislikütus
          </title>
          <meta
            name="description"
            content="Soovid osta diislikütust, bensiin 95, bensiin 98, 
						erimärgistusega diislikütust või biokütust? Korralda vedelkütuse hange
						Turgoilis, Eesti vedelkütuse hankeid vahendav veebikeskkond."
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, user-scalable=no"
          />
        </Helmet>
        <div className="landing-page">

          <Header location="landing-page" />

          <Section backgroundColor="#white">
            <div className="sloganContainer">
              <LandingSlogan />
            </div>
          </Section>

          <hr />

          <Section backgroundColor="#fff">
            <Counters
              oil_request_count={oil_request_count}
              liters={liters}
              total_sum={total_sum}
            />
          </Section>

          {/*<div style={{ display: 'flex', justifyContent: 'center', color: '#e7e5e5', fontSize: '24px', fontWeight: '500' }}>Meid usaldavad kliendid</div>
          <hr />

          <Section backgroundColor="#fff">
            <div className="clientsContainer">
              <Clients />
            </div>
          </Section>
          */}
          <Section backgroundColor="#white">
            <div className="benefitsConteiner">
              <Benefits />
            </div>
          </Section>

          <Section backgroundColor="#fff">
            <Tutorial />
          </Section>

          <hr />

          <Section backgroundColor="#fff">
            <div className="newsContainer">
              <News />
            </div>
          </Section>

          <div style={{ display: 'flex', justifyContent: 'center', color: '#e7e5e5', fontSize: '24px', fontWeight: '500' }}>Koostööpartnerid</div>
          <Footer rootFolder={""} />
        </div>
      </div>
    );
  }
}

export default LandingPage;
